import {object, string} from 'yup';
import {getRequiredMessage} from '../utils/message-helper';
import {PHONE, URL} from "../utils/regx";

export const clientRegistrationSchema = object({
  first_name: string().required(getRequiredMessage('First Name')),
  last_name: string().required(getRequiredMessage('Last Name')),
  email_address: string()
    .email('Enter correct email address')
    .required(getRequiredMessage('Email')),
  password: string()
    .min(6, 'Min length is 6 symbols')
    .required(getRequiredMessage('Password')),
  name: string().required('Name is required'),
  role: string().required('Role is required'),
  promo_code: string(),
  company_size: string().required('Company Size is required'),
  website: string()
      .matches(URL, 'Enter correct url!')
      .required('Please enter website'),
  phone_number: string().matches(PHONE, 'Enter correct phone').required('').required('Phone is required'),
});
